import React, { useEffect } from "react";
import { Grid, IconButton, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CustomButton, icon, IconComponent } from "../../../../common/components";
import { translate } from "../../../../common/providers";

import {
	setResetAddUserLicenceManagement,
	setResetViewUserLicenceManagement,
	setUpdateLicenceManagement,
} from "../../../../common/slice";
import UserDrawer from "../user-drawer/UserDrawer";
import FormAddProfile from "../form/FormAddProfile";
import { useApi } from "../../../../common/hooks";
import { LicenceManagementService } from "../../../../api";
import LoadingOverlay from "../../../../common/components/loaders/LoadingOverlay";
import styles from "./UserSearch.module.css";
import SearchInput from "../../../../common/components/text-fields/search-input/SearchInput";

export default function UserSearch() {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const [searchValue, setValueSearch] = React.useState(licenceManagementStore.search.searchUserName);
	const [openDrawer, setOpenDrawer] = React.useState(false);
	const [checkAddUserPayload, setCheckAddUserPayload] = React.useState(true);
	const [isLoading, setIsLoading] = React.useState(false);
	const dispatch = useDispatch();
	const { call: addUser } = useApi(LicenceManagementService.addUser);

	const handelSearchInputProps = () => {
		dispatch(
			setUpdateLicenceManagement({ search: { ...licenceManagementStore.search, searchUserName: searchValue } })
		);
	};
	const handelSearchInput = (e) => {
		setValueSearch(e.target.value);
		if (e.target.value === "") {
			dispatch(setResetViewUserLicenceManagement());
		}
	};
	const handelCloseDrawer = () => {
		setOpenDrawer(false);
	};
	const handelAddUser = () => {
		setIsLoading(true);
		const dataToSend = {
			...licenceManagementStore.addUser,
			bu: licenceManagementStore.addUser.contracts
				? null
				: licenceManagementStore.addUser.bu?.map((item) => item.valueUuid),
		};
		addUser({ payload: dataToSend })
			.then(() => {
				dispatch(setResetAddUserLicenceManagement());
				setIsLoading(false);
				handelCloseDrawer();
			})
			.catch((e) => {
				console.error(e);
				setIsLoading(false);
			});
	};

	useEffect(() => {
		const testRequiredInput =
			licenceManagementStore.addUser.email !== "" &&
			licenceManagementStore.firstname !== "" &&
			licenceManagementStore.addUser.lastname !== "" &&
			licenceManagementStore.addUser.role !== "";
		const testBU =
			licenceManagementStore.addUser.contracts ||
			licenceManagementStore.addUser.certificates ||
			(!licenceManagementStore.addUser.contracts &&
				licenceManagementStore?.addUser?.bu &&
				licenceManagementStore.addUser?.bu?.length > 0);
		setCheckAddUserPayload(!(testRequiredInput && testBU));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [licenceManagementStore.addUser]);

	return (
		<>
			<div className={styles.container}>
				{isLoading && <LoadingOverlay />}
				<Grid item md={8}>
					<SearchInput
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton onClick={handelSearchInputProps}>
										<IconComponent color="var(--grey-400)" icon={icon.faSearch} />
									</IconButton>
								</InputAdornment>
							),
						}}
						placeholder={translate("license-management.users-search.search")}
						size="small"
						value={searchValue}
						variant="outlined"
						onChange={(e) => {
							handelSearchInput(e);
						}}
						onKeyDown={(event) => {
							if (event.key === "Enter") {
								handelSearchInputProps();
							}
						}}
					/>
				</Grid>
				<CustomButton
					color="primary"
					data-testid="add.user.button"
					size="md"
					startIcon={icon.faPlus}
					variant="contained"
					onClick={() => setOpenDrawer(true)}
				>
					{translate("license-management.users-search.add")}
				</CustomButton>
			</div>
			<UserDrawer
				childrens={<FormAddProfile />}
				closeDrawer={() => {
					dispatch(setResetAddUserLicenceManagement());
					handelCloseDrawer();
				}}
				disabled={checkAddUserPayload}
				onclick={handelAddUser}
				open={openDrawer}
				title={translate("license-management.users-search.add")}
			/>
		</>
	);
}
